import { render } from "./HelpFunctionalityList.vue?vue&type=template&id=65ed50f2&scoped=true&ts=true"
import script from "./HelpFunctionalityList.vue?vue&type=script&lang=ts"
export * from "./HelpFunctionalityList.vue?vue&type=script&lang=ts"

import "./HelpFunctionalityList.vue?vue&type=style&index=0&id=65ed50f2&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65ed50f2"]])

export default __exports__